import { memo } from 'react'

const MentorCardPlaceholder: React.FC = memo(() => {
  return (
    <div className="tc-mv-card-item p-4">
      <div className="companion-placeholder animate-pulse flex justify-center items-center">
        <div className="text-white bg-[#8080804d] absolute px-4 py-2 rounded-full text-xs top-[35%] left-1/2 -translate-x-1/2 z-10 border-[1px] border-[#ffffff66]">
          Generating companion...
        </div>

        <div className="mt-auto me-auto max-w-full">
          <div className="w-24 h-[16px] bg-dark-neutral-400 rounded-full animate-pulse border-0 !mb-2" />
          <div className="w-80 max-w-full h-[24px] bg-dark-neutral-400 rounded-full animate-pulse border-0 !mb-2" />
          <div className="w-48 h-[16px] bg-dark-neutral-400 rounded-full animate-pulse border-0" />
        </div>
      </div>
    </div>
  )
})

export { MentorCardPlaceholder }
